import { FC, PropsWithChildren } from "react";
import Typography from "_ui-kit/components/Typography";
import styled, { useTheme } from "styled-components";

interface MessageToastProps {
  title?: string;
}

export const MessageToast: FC<PropsWithChildren<MessageToastProps>> = ({ title, children }) => {
  const theme = useTheme();

  return (
    <Container>
      {
        title && (
          <Typography variant="bodyM16" color={theme.palette.textIcon.baseInverted}>{title}</Typography>
        )
      }
      <Body variant="captionR14" color={theme.palette.textIcon.baseInverted}>{children}</Body>
    </Container>
  )
};

const Container = styled.div`
  width: 100%;
`;

const Body = styled.div``;
